interface OwnerSystem {
  locale: String;
  title: string;
  description: string;
  data: Array<{
    icon?: string;
    title: string;
    description: string;
  }>;
}

export default class OwnerSystemLocale {
  public data: Array<{
    icon?: string;
    title: string;
    description: string;
  }> = [];
  public title: string = "";
  public description: string = "";
  constructor() {
    const { locale } = useI18n();
    const mixLocale = dataLocales.find((item) => item.locale == locale.value);
    this.data = mixLocale?.data ?? dataLocales[0].data;
    this.title = mixLocale?.title ?? dataLocales[0].title;
    this.description = mixLocale?.description ?? dataLocales[0].description;
  }
}
const dataLocales: Array<OwnerSystem> = [
  {
    locale: "en",
    title: "Your Own System",
    description:
      "Build a QR code management system OR integrate it into your own information syste",
    data: [
      {
        icon: "business.png",
        title: "Small program for businesses",
        description:
          "Support for businesses with several modules in marketing, product management and measurement.",
      },
      {
        icon: "api.png",
        title: "API Integration",
        description:
          "Integrate the QR code generation system by API. Now you don't need to create a QR module in your system.",
      },
      {
        icon: "database.png",
        title: "Standalone database",
        description:
          "Provide an independent cloud database for each user can be used to connect to third-party tools.",
      },
    ],
  },
  {
    locale: "de",
    title: "Ihr eigenes System",
    description:
      "Bauen Sie ein QR-Code-Management-System auf ODER integrieren Sie es in Ihr eigenes Informationssystem",
    data: [
      {
        icon: "business.png",
        title: "Kleines Programm für Unternehmen",
        description:
          "Unterstützung für Unternehmen mit mehreren Modulen in Marketing, Produktmanagement und Messung.",
      },
      {
        icon: "api.png",
        title: "API-Integration",
        description:
          "Integrieren Sie das QR-Code-Erzeugungssystem per API. Jetzt müssen Sie kein QR-Modul in Ihrem System erstellen.",
      },
      {
        icon: "database.png",
        title: "Eigenständige Datenbank",
        description:
          "Stellen Sie eine unabhängige Cloud-Datenbank für jeden Benutzer bereit, die verwendet werden kann, um eine Verbindung zu Tools von Drittanbietern herzustellen.",
      },
    ],
  },
  {
    locale: "it",
    title: "Il tuo sistema",
    description:
      "Costruisci un sistema di gestione del codice QR O integralo nel tuo sistema informativo",
    data: [
      {
        icon: "business.png",
        title: "Piccolo programma per le imprese",
        description:
          "Supporto per le aziende con diversi moduli di marketing, gestione del prodotto e misurazione.",
      },
      {
        icon: "api.png",
        title: "Integrazione API",
        description:
          "Integra il sistema di generazione del codice QR tramite API. Ora non è necessario creare un modulo QR nel sistema.",
      },
      {
        icon: "database.png",
        title: "Database autonomo",
        description:
          "Fornire un database cloud indipendente per ogni utente può essere utilizzato per connettersi a strumenti di terze parti.",
      },
    ],
  },
  {
    locale: "es",
    title: "Tu Propio Sistema",
    description:
      "Cree un sistema de gestión de códigos QR O intégrelo en su propio sistema de información",
    data: [
      {
        icon: "business.png",
        title: "Pequeño programa para empresas",
        description:
          "Soporte a empresas con varios módulos en marketing, gestión de productos y medición.",
      },
      {
        icon: "api.png",
        title: "Integración API",
        description:
          "Integre el sistema de generación de códigos QR por API. Ahora no necesita crear un módulo QR en su sistema.",
      },
      {
        icon: "database.png",
        title: "Base de datos independiente",
        description:
          "Proporcionar una base de datos en la nube independiente para que cada usuario se pueda utilizar para conectarse a herramientas de terceros.",
      },
    ],
  },
  {
    locale: "fr",
    title: "Votre propre système",
    description:
      "Construisez un système de gestion de QR code OU intégrez-le dans votre propre système d'information",
    data: [
      {
        icon: "business.png",
        title: "Petit programme pour les entreprises",
        description:
          "Accompagnement des entreprises avec plusieurs modules en marketing, gestion de produits et mesure.",
      },
      {
        icon: "api.png",
        title: "Intégration des API",
        description:
          "Intégrez le système de génération de QR code par API. Désormais, vous n'avez plus besoin de créer un module QR dans votre système.",
      },
      {
        icon: "database.png",
        title: "Base de données autonome",
        description:
          "Fournir une base de données cloud indépendante pour chaque utilisateur peut être utilisée pour se connecter à des outils tiers.",
      },
    ],
  },
  {
    locale: "ja",
    title: "あなた自身のシステム",
    description:
      "QRコード管理システムを構築するか、独自の情報システムに統合します",
    data: [
      {
        icon: "business.png",
        title: "企業向けの小規模プログラム",
        description:
          "マーケティング、製品管理、測定のいくつかのモジュールを備えたビジネスのサポート。",
      },
      {
        icon: "api.png",
        title: "API統合",
        description:
          "APIによるQRコード生成システムの統合。これで、システムにQRモジュールを作成する必要はありません。",
      },
      {
        icon: "database.png",
        title: "スタンドアロンデータベース",
        description:
          "サードパーティのツールに接続するために使用できる各ユーザーに独立したクラウドデータベースを提供します。",
      },
    ],
  },
  {
    locale: "vi",
    title: "Hệ thống của riêng bạn",
    description:
      "Xây dựng hệ thống quản lý mã Qr hoặc tích hợp nó vào hệ thống thông tin của riêng bạn",
    data: [
      {
        icon: "business.png",
        title: "Chương trình nhỏ dành cho doanh nghiệp",
        description:
          "Hỗ trợ cho các doanh nghiệp với một số mô-đun trong tiếp thị, quản lý sản phẩm và đo lường.",
      },
      {
        icon: "api.png",
        title: "Tích hợp API",
        description:
          "Tích hợp hệ thống tạo mã QR bằng API. Bây giờ bạn không cần tạo mô-đun QR trong hệ thống của mình.",
      },
      {
        icon: "database.png",
        title: "Cơ sở dữ liệu độc lập",
        description:
          "Cung cấp cơ sở dữ liệu đám mây độc lập cho mỗi người dùng có thể được sử dụng để kết nối với các công cụ của bên thứ ba.",
      },
    ],
  },
  {
    locale: "nl",
    title: "Uw eigen systeem",
    description:
      "Bouw een QR-codebeheersysteem OF integreer het in uw eigen informatiesysteem",
    data: [
      {
        icon: "business.png",
        title: "Klein programma voor bedrijven",
        description:
          "Ondersteuning voor bedrijven met verschillende modules op het gebied van marketing, productbeheer en meting.",
      },
      {
        icon: "api.png",
        title: "API-integratie",
        description:
          "Integreer het QR-codegeneratiesysteem via API. U hoeft nu geen QR-module in uw systeem aan te maken.",
      },
      {
        icon: "database.png",
        title: "Zelfstandige database",
        description:
          "Zorg voor een onafhankelijke clouddatabase die voor elke gebruiker kan worden gebruikt om verbinding te maken met tools van derden.",
      },
    ],
  },
  {
    locale: "pt",
    title: "Seu Próprio Sistema",
    description:
      "Construir um sistema de gerenciamento de código QR OU integrá-lo em seu próprio sistema de informação",
    data: [
      {
        icon: "business.png",
        title: "Pequeno programa para empresas",
        description:
          "Suporte a negócios com diversos módulos em marketing, gestão de produtos e medição.",
      },
      {
        icon: "api.png",
        title: "Integração API",
        description:
          "Integre o sistema de geração de código QR por API. Agora você não precisa criar um módulo QR em seu sistema.",
      },
      {
        icon: "database.png",
        title: "Banco de dados independente",
        description:
          "Fornece um banco de dados em nuvem independente para que cada usuário possa ser usado para se conectar a ferramentas de terceiros.",
      },
    ],
  },
  {
    locale: "zh",
    title: "您自己的系统",
    description: "构建QR码管理系统或将其集成到您自己的信息系统中",
    data: [
      {
        icon: "business.png",
        title: "企业小程序",
        description: "为企业提供支持的多个模块，包括市场营销、产品管理和测量。",
      },
      {
        icon: "api.png",
        title: "API集成",
        description:
          "通过API集成QR码生成系统。现在您不需要在系统中创建QR模块。",
      },
      {
        icon: "database.png",
        title: "独立数据库",
        description: "为每个用户提供独立的云数据库，可用于连接第三方工具。",
      },
    ],
  },
];
